import Button from "elements/Button";
import React from "react";
import { formatPrice } from "utils/Formatter";

export default function ProductAction({ data }) {
  return (
    <div className="card product-action">
      <div className="d-flex justify-content-start">
        <img
          className="img-fluid me-3"
          src="https://ui-avatars.com/api/?name=Seller+A&background=023e7d&color=ffffff&size=100"
          alt=""
        />
        <div className="align-self-center">
          <h4 className="mb-1">SELLER A</h4>
          <p className="m-0">Kuningan</p>
        </div>
      </div>
      <div className="my-3">
        <h5>Harga</h5>
        <h3 className={data ? "" : "loading-text"}>
          Rp. {data ? formatPrice(data.data.price) : "Loading"}
        </h3>
      </div>
      <Button className="btn" isPrimary>
        Tertarik dan Nego
      </Button>
    </div>
  );
}
